'use client'
import {
  IMAGE_QUERY
} from "./chunk-CWCKFIZP.mjs";

// src/api/common/organizer.ts
var ORGANIZER_QUERY = `
id
title
href
logo {${IMAGE_QUERY}}
slug
`;

export {
  ORGANIZER_QUERY
};
//# sourceMappingURL=chunk-AWPL6XVN.mjs.map